module.exports = __webpack_public_path__ + "img/remove_the_two_bottom.b64c2b4b.jpg";